import script from "./AcceptTermsAndPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./AcceptTermsAndPolicy.vue?vue&type=script&setup=true&lang=js"

import "./AcceptTermsAndPolicy.vue?vue&type=style&index=0&id=373a2ce0&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-373a2ce0"]])

export default __exports__